/** @module MaterialSpec/MainMaterialGroupRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Enum"
], function(declare, Enum) {

	return declare(Enum, {
		bCopy: true,

		/**
		 * C8-11400: Drag-fill editing - do not allow drag fill into a Main Placement. Okay to drag-fill in all other cases.
		 */
		canPaste(ctxCopy, ctxPaste, h) {
			return !ctxPaste.getNode().MainMaterial && this.inherited(arguments);
		}
	});
});